import { useSDK } from '@/features/web3/hook';
import { useChainId, useUserAddr } from '../web3/useChain';

import { QUERY_KEYS } from '@/constants/query';
import { useQuery } from '@tanstack/react-query';

/**
 * useIsBlacklisted
 * React Query based hook to check if current user is blacklisted via Gate contract.
 */
export default function useIsBlacklisted(): { isBlacklisted: boolean } {
  const chainId = useChainId();
  const userAddress = useUserAddr();
  const sdk = useSDK(chainId);

  const { data } = useQuery({
    // Include sdk and gate presence to satisfy exhaustive-deps for queryKey
    queryKey: [...QUERY_KEYS.USER.IS_BLACKLISTED(chainId, userAddress), !!sdk, !!sdk?.perp?.contracts?.gate],
    queryFn: async () => {
      if (!sdk || !userAddress || !sdk.perp?.contracts?.gate) return false;
      return sdk.perp.contracts.gate.isBlacklisted(userAddress);
    },
    enabled: !!sdk && !!userAddress && !!sdk.perp?.contracts?.gate,
  });

  return { isBlacklisted: !!data };
}
